<template>
  <div class="row">
    <div class="col-12 animate__animated animate__slow animate__delay">
      <fieldset>
        <form @submit.prevent="cadastrar" class="row">
          <InputText classDiv="col-md-6" placeholder="" label="Nome *" tamanho="sm" v-model="nome" />

          <InputTextMask classDiv="col-md-6" placeholder="" nome="celular" label="Celular *" mask="cel" tamanho="sm"
            v-model="celular" />
          <InputText classDiv="col-md-6" placeholder="" nome="email" tipo="email" label="Email *" mask="email"
            tamanho="sm" v-model="email" />
          <InputText classDiv="col-md-6" placeholder="" nome="cidade_votacao" label="Cidade onde vota *" tamanho="sm"
            v-model="cidade_votacao" />

          <InputText classDiv="col-md-6" placeholder="" nome="senha" tipo="password" :btn_lock="true" label="Senha *" tamanho="sm"
            v-model="senha" />
          <InputText classDiv="col-md-6" placeholder="" nome="confirma_senha" tipo="password" :btn_lock="true" label="Confirme sua senha"
            tamanho="sm" v-model="confirma_senha" />

          <InputText classDiv="col-md-6" placeholder="" nome="codigo_multiplicador" tipo="codigo_multiplicador"
            label="Código do Eleitor Multiplicador" mask="codigo_multiplicador"
            tooltip="Código do Eleitor multiplicaador que indicou para o cadastro, caso não tenha deixar em branco."
            tamanho="sm" v-model="codigo_multiplicador" :desabilitado="desabilita_cod_multi" />

          <div class="col-md-6 mx-auto text-center text-md-end row">
            <div class="col-md-12 text-start p-0">
              <div class="col-12 text-center">
                <TermosAdesao></TermosAdesao>
              </div>
              <InputCheckbox label="Li e concordo com os termos de uso apresentados aqui." nome="termos_uso" @change="termos_uso = !termos_uso"></InputCheckbox>
            </div>
            <div class="col-md-12">
              <span class="me-2 fs-4 fw-bold">
                Clique aqui
                <i class="bi bi-arrow-right d-none d-sm-inline" style="color: var(--cor-base-texto);"></i>
                <i class="bi bi-arrow-down d-sm-none" style="color: var(--cor-base-texto);"></i>
              </span>

              <div type="submit" class="btn btn-lg fw-bold py-1 disabled" v-if="!termos_uso"
                style="background-color: var(--cor-base-texto); color: #FFF; padding-top: 2px !important;">
                Saia do sofá
                <Spinner :visivel="false" id="loading" />
              </div> 
              <button type="submit" class="btn btn-lg fw-bold py-1" v-if="termos_uso"
                style="background-color: var(--cor-base-texto); color: #FFF; padding-top: 2px !important;">
                Saia do sofá
                <Spinner :visivel="false" id="loading" />
              </button> 
            </div>
          </div>
        </form>
      </fieldset>
    </div>
  </div>
</template>

<script>
import InputText from "./form/InputText.vue";
import InputTextMask from "./form/InputTextMask.vue";
import { api } from "@/services/api";
import { toastr } from '@/plugins/toast.js'
import Spinner from "./Spinner.vue";
import { saudacao } from "@/assets/js/functions"
import InputCheckbox from "./form/InputCheckbox.vue";
import TermosAdesao from "./TermosAdesao.vue";

export default {
  name: "FormularioCadastro",
  components: {
    InputText,
    InputTextMask,
    InputCheckbox,
    Spinner,
    TermosAdesao,
  },
  data() {
    return {
      cod_indicacao: this.$route.params.cod,
      desabilita_cod_multi: false,
      nome: '',
      celular: '',
      email: '',
      cidade_votacao: '',
      codigo_multiplicador: '',
      senha: '',
      confirma_senha: '',
      termos_uso: false,
    }
  },
  methods: {
    async cadastrar(e) {
      e.preventDefault();

      if (!this.nome) {
        toastr.alerta("Digite seu nome")
        return false;
      }

      if (!this.celular) {
        toastr.alerta("Digite seu telefone")
        return false;
      }

      if (!this.email) {
        toastr.alerta("Digite seu Email")
        return false;
      }

      if (!this.cidade_votacao) {
        toastr.alerta("Digite a cidade em que vota")
        return false;
      }

      if (!this.senha) {
        toastr.alerta("Digite uma senha")
        return false;
      } else

        if (this.senha.length < 8) {
          toastr.alerta("A senha deve ter pelo menos 8 caracteres")
          return false;
        }

      if (this.senha != this.confirma_senha) {
        toastr.alerta("As senhas digitadas não conferem.")
        return false;
      }

      if(!this.termos_uso) {
        toastr.alerta("Para concluir o cadastro clique em 'Li e concordo com os termos de uso apresentados aqui'.")
        return false;
      }

      const dados = {
        nome: this.nome,
        celular: this.celular,
        email: this.email,
        cidade_votacao: this.cidade_votacao,
        codigo_multiplicador: this.codigo_multiplicador,
        senha: this.senha,
      };

      const campos = document.querySelector('fieldset')
      const loading = document.querySelector('#loading')
      campos.setAttribute('disabled', 'disabled')
      loading.classList.remove('d-none');
      try {
        const data = await api.post('user/register', dados)
        loading.classList.add('d-none');

        if (data.status == 200) {
          toastr.sucesso(data.message)
          this.nome = '';
          this.celular = '';
          this.email = '';
          this.cidade_votacao = '';
          this.codigo_multiplicador = '';
          this.senha = '';
          this.confirma_senha = '';

          this.chama_zap();
        } else if (data.status == 401) {
          for (const key in data.message) {
            toastr.erro(data.message[key]);
          }
        } else {
          toastr.erro(data.message);
        }
      } catch (error) {
        toastr.erro("Erro ao cadastrar.");
      }
      loading.classList.add('d-none');
      campos.removeAttribute('disabled')

    },
    chama_zap() {
      var txt_cadastro = saudacao() + ` Kadu, acabei de fazer o cadastro em saiadosofabr.com.br e gostaria de saber mais sobre o projeto.`;

      var href_full = `https://api.whatsapp.com/send?phone=5524998781800&text=` + txt_cadastro;

      window.open(href_full, '_blank');
      return false
    },
  },
  mounted() {
    if (this.cod_indicacao != undefined) {
      localStorage.setItem('cod_indicacao', this.cod_indicacao)
      this.codigo_multiplicador = this.cod_indicacao
      this.desabilita_cod_multi = true;
    } else if (localStorage.getItem('cod_indicacao') != null) {
      this.codigo_multiplicador = localStorage.getItem('cod_indicacao')
      this.desabilita_cod_multi = true;
    }
  },
};
</script>

<style scoped></style>